import React from "react";
import { EALogo } from "@/components/brand/EALogo";

export const Footer = () => (
  <footer className="relative bg-ink-950 border-t border-white/10" data-testid="site-footer">
    <div className="mx-auto max-w-[1600px] px-6 md:px-10 py-16">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <span className="text-spectrum-green"><EALogo size={40} strokeWidth={6} /></span>
            <div>
              <div className="font-display text-white font-bold tracking-tight">Svenska Invest</div>
              <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/50">EA · Software IP holding</div>
            </div>
          </div>
          <p className="text-white/60 text-sm max-w-sm leading-relaxed">
            A convertible-bond financed software IP company building the Merkle
            ledger for IoT-driven, inter-ERP audited commerce.
          </p>
        </div>

        <FooterCol title="Company">
          <FooterLink href="#manifesto">Thesis</FooterLink>
          <FooterLink href="#portfolio">Portfolio</FooterLink>
          <FooterLink href="#careers">Careers</FooterLink>
        </FooterCol>

        <FooterCol title="Bond">
          <FooterLink href="#bond">Prospectus</FooterLink>
          <FooterLink href="mailto:erik@svenskainvest.com?subject=Term%20Sheet">Term sheet</FooterLink>
          <FooterLink href="mailto:erik@svenskainvest.com?subject=Investor%20Deck">Investor deck</FooterLink>
        </FooterCol>

        <FooterCol title="Contact">
          <FooterLink href="mailto:erik@svenskainvest.com">erik@svenskainvest.com</FooterLink>
          <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/50">Stockholm · Sweden</div>
          <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/50">Global mandate</div>
        </FooterCol>
      </div>

      <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40">
          © {new Date().getFullYear()} Svenska Invest / EA. All rights reserved.
        </div>
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40">
          This site is not a public offer. Investment involves risk.
        </div>
      </div>
    </div>
  </footer>
);

const FooterCol = ({ title, children }) => (
  <div className="md:col-span-2">
    <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-spectrum-green mb-4">{title}</div>
    <ul className="space-y-3">{React.Children.map(children, (c) => <li>{c}</li>)}</ul>
  </div>
);

const FooterLink = ({ href, children }) => (
  <a
    href={href}
    className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/70 hover:text-spectrum-green transition-colors"
  >
    {children}
  </a>
);
